import { type OptionSelectionProps } from '@shared/components';

import { type BlockedInformationCreationFieldsProps } from '../blocked-information-creation-fields';

import CheaterBlockedRecordInfoFormField from './cheater-blocked-record-info-form-field';
import StaffBlockedRecordInfoFormField from './staff-blocked-record-info-form-field';
import { type BaseFieldsProps } from './types';

export type BlockRecordInfoFormFieldsVariant = 'cheater' | 'exam-center-manager' | 'staff';

export type BlockedRecordInfoFormFieldsProps = BlockedInformationCreationFieldsProps & {
  fields: {
    blockedType: BaseFieldsProps & { options: OptionSelectionProps[] };
    position: BaseFieldsProps;
    department: BaseFieldsProps;
    examDate: BaseFieldsProps;
    examRound: BaseFieldsProps;
    examStartTime: BaseFieldsProps;
    examEndTime: BaseFieldsProps;
    fileDocuments: BaseFieldsProps;
  };
  visibleSections?: {
    examSessions?: boolean;
    fileDocuments?: boolean;
  };
  variant: BlockRecordInfoFormFieldsVariant;
};

export default function BlockedRecordInfoFormFields(
  props: Readonly<BlockedRecordInfoFormFieldsProps>,
) {
  const { fields, options, visibleFields, slots, variant } = props;

  switch (variant) {
    case 'cheater':
      return (
        <CheaterBlockedRecordInfoFormField
          fields={fields}
          options={options}
          visibleFields={{
            ...visibleFields,
            examCenter: true,
          }}
          slots={slots}
        />
      );
    case 'exam-center-manager':
      return (
        <StaffBlockedRecordInfoFormField
          fields={fields}
          options={options}
          visibleFields={{
            ...visibleFields,
            examCenter: true,
          }}
          slots={slots}
        />
      );
    case 'staff':
    default:
      return (
        <StaffBlockedRecordInfoFormField
          fields={fields}
          options={options}
          visibleFields={visibleFields}
          slots={slots}
        />
      );
  }
}
